interface StatusBadgeProps {
  status: 'healthy' | 'degraded' | 'down' | 'unknown';
}

const colors: Record<string, string> = {
  healthy: 'bg-green-500/20 text-green-400 border-green-500/30',
  degraded: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30',
  down: 'bg-red-500/20 text-red-400 border-red-500/30',
  unknown: 'bg-gray-500/20 text-gray-400 border-gray-500/30',
};

const labels: Record<string, string> = {
  healthy: 'Saudável',
  degraded: 'Degradado',
  down: 'Offline',
  unknown: 'Desconhecido',
};

export function StatusBadge({ status }: StatusBadgeProps) {
  return (
    <span class={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium border ${colors[status] || colors.unknown}`}>
      <span class={`w-1.5 h-1.5 rounded-full ${status === 'healthy' ? 'bg-green-400' : status === 'degraded' ? 'bg-yellow-400' : status === 'down' ? 'bg-red-400' : 'bg-gray-400'}`} />
      {labels[status] || status}
    </span>
  );
}

interface SeverityBadgeProps {
  severity: 'S1' | 'S2' | 'S3' | 'S4' | string;
}

const sevColors: Record<string, string> = {
  S1: 'bg-red-500/20 text-red-400 border-red-500/30',
  S2: 'bg-orange-500/20 text-orange-400 border-orange-500/30',
  S3: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30',
  S4: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
};

export function SeverityBadge({ severity }: SeverityBadgeProps) {
  return (
    <span class={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-bold border ${sevColors[severity] || sevColors.S4}`}>
      {severity}
    </span>
  );
}
